import BannerLayout from "../../../../layouts/bannerLayout";
import CalculatorResults from "../calculatorResults";
import CalculatorWebFilter from "./calculatorWebFilter";

const CalculatorWebLayout = ({
    navOption,
    formView,
    defaultData,
    backToFilterView,
    moveToFormView,
    buttonLoading,
    allowDistanceEdit
}) => {
    return (
        <>
            {
                formView
                ?
                <BannerLayout 
                    navOptionIndex={navOption}
                    title="Plan Your Perfect Tour  Instantly!"
                    description="Easily estimate your tour costs with real-time distance, vehicle, and day selections."
                    children={<CalculatorResults backToFilterView={backToFilterView}/>}
                />
                :
                <CalculatorWebFilter 
                    defaultData={defaultData} 
                    moveToFormView={moveToFormView}
                    buttonLoading={buttonLoading}
                    allowDistanceEdit={allowDistanceEdit}
                />
            }
        </>
    );
}

export default CalculatorWebLayout;